import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from "react";
import DeleteIcon from "@mui/icons-material/DeleteForeverRounded";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { RAIL_LABEL } from "../../../constants/configuration.const";
import DragHandleIcon from "@mui/icons-material/DragIndicator";
import LockIcon from "@mui/icons-material/Lock";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import axios from "../../../utils/axiosInstance";
import { useSnackbar } from "notistack";
import {
    Autocomplete,
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    Paper,
    Radio,
    RadioGroup,
    TextField,
    Tooltip,
    Typography,
    createFilterOptions,
    styled,
} from "@mui/material";
import BannerForm from "./BannerForm";
import GenreForm from "./GenreForm";
import { Check, Close } from "@mui/icons-material";
import {
    BANNER_ACCEPTED_FILE,
    BANNER_DIMENSION,
    BANNER_ERROR_MESSAGE,
    BANNER_PLACEHOLDER_MESSAGE_WEB,
    GENRE_RAIL_TITLE,
    NO_CONTENT_PLAYLIST,
    SYNOPSIS_LIMIT,
    THEMATIC_BACKGROUNG_SELECTION,
    THEMATIC_MIN_IMAGE_DIMENSION,
    THEMATIC_PLACEHOLDER_MESSAGE,
    THEMATIC_VALIDATION,
} from "../LandingPage/constants";
import { StyledDropzone } from "../../UI/Common/FileUploader";
import { Field, Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";

import { ChromePicker } from "react-color";
import { ColorPicker } from "../../UI/Common/ColorPicker";
import GeneralModalV1 from "../../UI/atoms/Popup/GeneralModalV1";
import { getPlaylistCount } from "../../../utilities/helpers/helperService";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
}));

const ThematicContentCurationCard = forwardRef(
    (
        {
            handleFormChange,
            playlist,
            dragHandleProps,
            onClickDelete,
            onClickEdit,
            onClickAdd,
            data,
            className,
            hideAddButton,
            allowEdit,
            handleRail,
            handleThematicTitle,
        }: any,
        ref: any
    ) => {
        const initialFormValue = {
            title: "",
            description: "",
            playlistId: "",
            playlistCount: null,
            backgroundColor: null,
            webImageForegroundUrl: "",
            webImageBackgroundUrl: "",
            mobileImageForegroundUrl: "",
            mobileImageBackgroundUrl: "",
            backgroundSelection: THEMATIC_BACKGROUNG_SELECTION.IMAGE,
        };

        // hooks
        const [showForm, setShowForm] = useState(false);
        const { enqueueSnackbar } = useSnackbar();
        const thematicRailRef = useRef<any>(null);
        const [errorMessage, setErrorMessage] = useState("");
        const [enableTitleEdit, setEnableTitleEdit] = useState(false);
        const [initialFormValueState, setInitialFormValueState] =
            useState(initialFormValue);
        const [playlistInfo, setPlaylistInfo] = useState<any>([]);
        const [isOpen, setIsOpen] = React.useState(false);
        const [showInfoPopup, setShowInfoPopup] = useState(false);
        const [selectedFile, setSelectedFile] = useState<any>(null);
        const [thematicRailTitle, setThematicRailTitle] = useState("");
        const [formValid, setFormValid] = useState<any>(null);
        const [formChangeKey, setFormChange] = useState<any>(null);
        const [webFgimageErrMessage, setWebFgImageErrMessage] = useState("");
        const [webBgimageErrMessage, setWebBgImageErrMessage] = useState("");
        const [mobileFgimageErrMessage, setMobileFgImageErrMessage] =
            useState("");
        const [mobileBgimageErrMessage, setMobileBgImageErrMessage] =
            useState("");
        const [webFgImageLoader, setWebFgImageLoader] = useState(false);
        const [webBgImageLoader, setWebBgImageLoader] = useState(false);
        const [mobileFgImageLoader, setMobileFgImageLoader] = useState(false);
        const [mobileBgImageLoader, setMobileBgImageLoader] = useState(false);

        useImperativeHandle(
            ref,
            () => ({
                onOpenForm,
                isValid,
                handleSubmit,
                getFormValue,
            }),
            [showForm, formChangeKey, formValid]
        );

        // manual formchange event
        const onFormChange = (field: string, value: string) => {
            console.log("formchange happ", field, value);
            setFormChange({ field, value });
        };

        // for the parent to access tje form isValid state
        const isValid = () => {
            console.log(formValid);
            // if form is already opened, get data from the formRef
            // else get it from the state
            if (showForm) {
                console.log(thematicRailRef.current);
                return thematicRailRef.current.isValid;
            } else {
                return formValid?.isValid == null ? null : formValid?.isValid;
            }
        };

        // for the parent to access the form submit
        const handleSubmit = () => {
            setShowForm(true);
            setTimeout(() => {
                thematicRailRef.current.handleSubmit();
            }, 100);
        };
        const getFormValue = () =>
            thematicRailRef?.current?.values || formValid.values;

        useEffect(() => {
            checkIfKeyPresent(data);
            console.log("useeffect", data);
            setInitialFormValueState({
                backgroundColor: data?.backgroundColor || "",
                description: data?.description || "",
                playlistId: data?.playlistId || "",
                playlistCount: data?.playlistCount || null,
                title: data?.title || "",
                webImageForegroundUrl: data?.webImageForegroundUrl || "",
                webImageBackgroundUrl: data?.webImageBackgroundUrl || "",
                mobileImageForegroundUrl: data?.mobileImageForegroundUrl || "",
                mobileImageBackgroundUrl: data?.mobileImageBackgroundUrl || "",
                backgroundSelection:
                    data?.backgroundSelection ||
                    THEMATIC_BACKGROUNG_SELECTION.IMAGE,
            });
        }, [data]);

        // on first time creation, there will not be a key called "description". this is make the form valid to false
        const checkIfKeyPresent = (data: any) => {
            if (!data) return;
            const keys = Object.keys(data);
            if (!keys.includes("description")) {
                setFormValid({ isValid: false });
            }
        };

        const handleOpenOptions = () => {
            setIsOpen(true);
        };

        const handleCloseOptions = () => {
            setIsOpen(false);
        };

        useEffect(() => {
            if (playlist && playlist.length) setPlaylistInfo(playlist);
        }, [playlist]);

        useEffect(() => {
            if (data) {
                setThematicRailTitle(data?.railTitle);
            }
        }, [data]);

        useEffect(() => {
            if (thematicRailRef?.current && thematicRailTitle) {
                thematicRailRef.current.setFieldValue(
                    "railTitle",
                    thematicRailTitle || ""
                );
            }
        }, [thematicRailTitle && thematicRailRef]);

        const onOpenForm = () => {
            setShowForm(true);
            setTimeout(() => {
                thematicRailRef.current.validateForm();
            }, 100);
        };

        // when closing the rail, make sure to persist the form validate & the form values
        const onCloseRail = () => {
            const { isValid, values } = thematicRailRef.current;
            setFormValid({ isValid, values });
            setShowForm(false);
            handleRail(thematicRailRef.current.values);
        };

        // on click on save button inside the rail
        const saveThematicRail = () => {
            // moves data to the parent
            const { isValid, values } = thematicRailRef.current;
            setFormValid({ isValid, values });
            handleRail(thematicRailRef.current.values);
            enqueueSnackbar("Thematic Rail Added", {
                variant: "info",
                autoHideDuration: 2000,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                },
            });
            setErrorMessage("");
            setShowForm(false);
        };

        // upload image
        const uploadImage = (files: any, fieldName: string) => {
            console.log("upload image", files);
            // check if the image is already -present
            const thematicRail = thematicRailRef.current.values;
            if (thematicRail && thematicRail[fieldName]) {
                // open dialog for confirmation
                setShowInfoPopup(true);
                setSelectedFileValue({ files, fieldName });
            } else {
                validateAndUploadFile(files[0], fieldName);
            }
        };

        const setSelectedFileValue = (files: any) => {
            setSelectedFile(files);
        };

        // Validate the file dimension & proceed with uploading the file
        const validateAndUploadFile = (file: any, fieldName: string) => {
            const { errMessage, setErrMessage }: any = imageInstance(fieldName);
            // CHECK ACCEPTED FILE FORMATS
            if (!(file && BANNER_ACCEPTED_FILE.includes(file.type))) return;
            const image = new Image();
            image.addEventListener("load", () => {
                console.log(`${image.width}x${image.height}`);
                // check if the width>= 3840 & height>=2160
                if (
                    (image.width >= THEMATIC_MIN_IMAGE_DIMENSION.WIDTH &&
                        fieldName == "webImageForegroundUrl") ||
                    fieldName !== "webImageForegroundUrl"
                ) {
                    //incase if the image container already has error message shown, remove it since dimension is good for upload
                    uploadImageAPI(file, fieldName);
                    setErrMessage("");
                } else {
                    // if the dimension is not good enough. Add the index of the banner to the error
                    if (!errMessage) {
                        setErrMessage(BANNER_ERROR_MESSAGE);
                    }
                }
            });
            image.src = URL.createObjectURL(file);
        };

        const imageInstance = (fieldName: any) => {
            if (fieldName == "webImageForegroundUrl")
                return {
                    errMessage: webFgimageErrMessage,
                    setErrMessage: setWebFgImageErrMessage,
                    setLoader: setWebFgImageLoader,
                };
            else if (fieldName == "webImageBackgroundUrl")
                return {
                    errMessage: webBgimageErrMessage,
                    setErrMessage: setWebBgImageErrMessage,
                    setLoader: setWebBgImageLoader,
                };
            else if (fieldName == "mobileImageForegroundUrl")
                return {
                    errMessage: mobileFgimageErrMessage,
                    setErrMessage: setMobileFgImageErrMessage,
                    setLoader: setMobileFgImageLoader,
                };
            else if (fieldName == "mobileImageBackgroundUrl")
                return {
                    errMessage: mobileBgimageErrMessage,
                    setErrMessage: setMobileBgImageErrMessage,
                    setLoader: setMobileBgImageLoader,
                };
        };

        // API for uploading image
        const uploadImageAPI = async (file: any, fieldName: string) => {
            const { setLoader }: any = imageInstance(fieldName);
            try {
                if (file) {
                    const formData = new FormData();
                    formData.append("file", file);
                    setLoader(true);
                    const uploadFile: any = await axios.post(
                        `${process.env.BASE_URL}api/v1/cms/page/upload-banner`,
                        formData
                    );
                    if (uploadFile?.data?.success) {
                        // if upload is success, update the image url of the specified banner index
                        const imageUrl = uploadFile?.data?.data?.url;
                        let thematicRail = thematicRailRef.current.values;
                        thematicRail[fieldName] = imageUrl;
                        thematicRailRef.current.setValues({ ...thematicRail });
                        enqueueSnackbar("Image Uploaded", {
                            variant: "info",
                            autoHideDuration: 2000,
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "center",
                            },
                        });
                    }
                }
            } catch (error: any) {
                console.log("Error uploading", error.response.data.message);
                if (error?.response?.data?.message) {
                    enqueueSnackbar(error?.response?.data?.message, {
                        variant: "error",
                    });
                } else {
                    enqueueSnackbar("Error when uploading image", {
                        variant: "error",
                    });
                }
            } finally {
                setLoader(false);
            }
        };

        const filterOptions = createFilterOptions({
            matchFrom: "any",
            stringify: (option: any) => option.name + option.id,
        });

        const renderOptionsInitial = (options: any) => {
            if (typeof options == "string") {
                const filterPlaylist = playlistInfo.filter(
                    (list: any) => list.id === options
                );
                if (filterPlaylist.length > 0) {
                    return (
                        filterPlaylist[0].name + " - " + filterPlaylist[0].id
                    );
                } else {
                    return "";
                }
            } else if (typeof options == "object") {
                return options.name + " - " + options.id;
            }
        };

        const closeInfoModal = () => {
            setShowInfoPopup(false);
            setSelectedFileValue(null);
        };

        const confirmUpload = () => {
            validateAndUploadFile(
                selectedFile?.files[0],
                selectedFile?.fieldName
            );
            setShowInfoPopup(false);
        };

        const handleBackgroundSelection = (e: any) => {
            onFormChange(
                "backgroundSelection",
                THEMATIC_BACKGROUNG_SELECTION.IMAGE
            );
            const formValues = thematicRailRef.current.values;
            if (e.target.checked) {
                thematicRailRef.current.setValues({
                    ...formValues,
                    webImageBackgroundUrl: "",
                    mobileImageBackgroundUrl: "",
                    backgroundSelection: THEMATIC_BACKGROUNG_SELECTION.COLOR,
                });
            } else {
                thematicRailRef.current.setValues({
                    ...formValues,
                    backgroundColor: "",
                    backgroundSelection: THEMATIC_BACKGROUNG_SELECTION.IMAGE,
                });
            }
        };

        return (
            <div
                className={
                    "curation-list-card-container d-flex j-center curation-card"
                }
            >
                <div {...dragHandleProps} className="d-flex float-center">
                    <DragHandleIcon className="drag-handle" />
                </div>
                <div className="curation-list-card hero-carousal-card-height">
                    {/* Row One */}
                    <div {...dragHandleProps} className="d-flex j-space">
                        <span className="curation-title">
                            #{RAIL_LABEL[data.template]}
                        </span>
                        <div className="f-bold">
                            {enableTitleEdit ? (
                                <>
                                    <TextField
                                        label="Thematic Title"
                                        id="outlined-size-small"
                                        value={thematicRailTitle}
                                        size="small"
                                        onChange={(e: any) => {
                                            const title = e.target.value || "";
                                            setThematicRailTitle(title);
                                        }}
                                    />
                                    <Tooltip title="Save Title">
                                        <IconButton
                                            disabled={
                                                thematicRailTitle.length == 0
                                            }
                                        >
                                            <Check
                                                onClick={() => {
                                                    setEnableTitleEdit(false);
                                                    handleThematicTitle(
                                                        thematicRailTitle
                                                    );
                                                }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Cancel">
                                        <IconButton>
                                            <Close
                                                onClick={() => {
                                                    setThematicRailTitle(
                                                        data?.railTitle
                                                    );
                                                    setEnableTitleEdit(false);
                                                }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            ) : (
                                <span
                                    onClick={() =>
                                        allowEdit && setEnableTitleEdit(true)
                                    }
                                >
                                    {" "}
                                    {thematicRailTitle}
                                </span>
                            )}
                            <div></div>
                        </div>
                        <div>
                            <span
                                className="cursor-pointer delete-circle-style"
                                onClick={onClickDelete}
                            >
                                {allowEdit && <DeleteIcon />}
                            </span>
                        </div>
                    </div>

                    {/* row content */}

                    {showForm && (
                        <Formik
                            innerRef={thematicRailRef}
                            initialValues={initialFormValueState}
                            enableReinitialize
                            validationSchema={Yup.object({
                                title: Yup.string()
                                    .required("Title is required")
                                    .max(
                                        THEMATIC_VALIDATION.TITLE,
                                        `Title must not exceed ${THEMATIC_VALIDATION.TITLE} characters`
                                    ),
                                description: Yup.string()
                                    .required("Description is required")
                                    .max(
                                        THEMATIC_VALIDATION.DESCRIPTION,
                                        `Description must not exceed ${THEMATIC_VALIDATION.DESCRIPTION} characters`
                                    ),
                                playlistId: Yup.string().required(
                                    "Playlist ID is required"
                                ),
                                playlistCount: Yup.number().min(1),
                                webImageBackgroundUrl: Yup.string().required(
                                    "Background image is required"
                                ),
                                mobileImageBackgroundUrl: Yup.string().required(
                                    "Background image is required"
                                ),
                            })}
                            onSubmit={saveThematicRail}
                        >
                            {({
                                values,
                                handleChange,
                                touched,
                                errors,
                                setFieldValue,
                                setFieldTouched,
                                setValues,
                                handleBlur,
                            }: any) => (
                                <Form>
                                    <Grid className="p-1" container spacing={2}>
                                        {/* First Column */}

                                        {/* Second Column */}
                                        <Grid item xs={12} md={5}>
                                            {/* <InputLabel shrink>Playlist Id</InputLabel> */}
                                            <div>
                                                <Autocomplete
                                                    id="bcPlaylistId"
                                                    options={playlistInfo}
                                                    filterOptions={
                                                        filterOptions
                                                    }
                                                    value={values.playlistId}
                                                    includeInputInList
                                                    size="small"
                                                    open={isOpen}
                                                    onChange={async (
                                                        e,
                                                        value
                                                    ) => {
                                                        onFormChange(
                                                            "playlistId",
                                                            value?.id
                                                        );
                                                        setFieldTouched(
                                                            `playlistId`,
                                                            true
                                                        );
                                                        const playlistCount =
                                                            await getPlaylistCount(
                                                                value?.id
                                                            );
                                                        const formValue = {
                                                            ...values,
                                                            playlistId:
                                                                value?.id || "",
                                                            playlistCount,
                                                        };
                                                        setValues({
                                                            ...formValue,
                                                        });
                                                    }}
                                                    onOpen={handleOpenOptions}
                                                    onClose={handleCloseOptions}
                                                    getOptionLabel={(
                                                        options: any
                                                    ) => {
                                                        return (
                                                            renderOptionsInitial(
                                                                options
                                                            ) || ""
                                                        );
                                                    }}
                                                    disabled={!allowEdit}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            name="playlistId"
                                                            label="BC Playlist Id"
                                                            value={
                                                                values.playlistId
                                                            }
                                                            variant="outlined"
                                                            error={
                                                                touched.playlistId &&
                                                                (Boolean(
                                                                    errors.playlistId
                                                                ) ||
                                                                    Boolean(
                                                                        errors.playlistCount
                                                                    ))
                                                            }
                                                            helperText={
                                                                touched.playlistId &&
                                                                values[
                                                                    `playlistId`
                                                                ] &&
                                                                !values[
                                                                    `playlistCount`
                                                                ] &&
                                                                NO_CONTENT_PLAYLIST
                                                            }
                                                            {...params}
                                                        />
                                                    )}
                                                />
                                            </div>

                                            <div className="mt-2 d-flex">
                                                <Checkbox
                                                    onChange={
                                                        handleBackgroundSelection
                                                    }
                                                    checked={
                                                        values?.backgroundSelection ==
                                                        THEMATIC_BACKGROUNG_SELECTION.COLOR
                                                    }
                                                    disabled
                                                />
                                                <ColorPicker
                                                    allowEdit={
                                                        allowEdit &&
                                                        values?.backgroundSelection ==
                                                            THEMATIC_BACKGROUNG_SELECTION.COLOR
                                                    }
                                                    error={
                                                        touched.backgroundColor &&
                                                        errors.backgroundColor
                                                    }
                                                    onBlur={handleBlur}
                                                    color={
                                                        values.backgroundColor
                                                    }
                                                    onChange={(
                                                        colorHex: any
                                                    ) => {
                                                        if (
                                                            typeof colorHex ==
                                                            "string"
                                                        ) {
                                                            onFormChange(
                                                                "backgroundColor",
                                                                colorHex
                                                            );
                                                            setFieldValue(
                                                                "backgroundColor",
                                                                colorHex
                                                            );
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </Grid>

                                        {/* Third Column */}
                                        <Grid item xs={12} md={5}>
                                            <Field
                                                name={`title`}
                                                as={TextField}
                                                label="Title"
                                                fullWidth
                                                value={values[`title`]}
                                                onChange={(e: any) => {
                                                    handleChange(e);
                                                    onFormChange(
                                                        "title",
                                                        e.target.value
                                                    );
                                                }}
                                                size={"small"}
                                                className="mb-1 w-95"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                error={
                                                    touched?.title &&
                                                    errors.title
                                                }
                                                helperText={
                                                    touched.title &&
                                                    errors.title
                                                }
                                                disabled={!allowEdit}
                                            />

                                            <Field
                                                name={`description`}
                                                as={TextField}
                                                label="Description"
                                                value={values[`description`]}
                                                onChange={(e: any) => {
                                                    const inputValue =
                                                        e.target.value;
                                                    setFieldValue(
                                                        `description`,
                                                        inputValue
                                                    );
                                                    onFormChange(
                                                        "description",
                                                        inputValue
                                                    );
                                                }}
                                                fullWidth
                                                className="mt-1 w-95"
                                                size={"small"}
                                                rows={4}
                                                multiline
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                error={
                                                    touched?.description &&
                                                    errors?.description
                                                }
                                                helperText={
                                                    touched.description &&
                                                    errors.description
                                                }
                                                disabled={!allowEdit}
                                            />
                                        </Grid>
                                    </Grid>
                                    {/* WEB IMAGE UPLOAD STARTS HERE */}
                                    <Typography variant="h6">
                                        CTV/Web/Tablet
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            md={5}
                                            className="mb-2"
                                        >
                                            <Item>
                                                <>
                                                    <Typography
                                                        className="text-align-left"
                                                        variant="body1"
                                                        fontWeight={600}
                                                    >
                                                        Foreground Image
                                                    </Typography>
                                                    <StyledDropzone
                                                        height={150}
                                                        disabled={!allowEdit}
                                                        onDropFile={(
                                                            file: any
                                                        ) => {
                                                            onFormChange(
                                                                "webImageForegroundUrl",
                                                                values.webImageForegroundUrl
                                                            );
                                                            uploadImage(
                                                                file,
                                                                "webImageForegroundUrl"
                                                            );
                                                            setFieldTouched(
                                                                `webImageForegroundUrl`,
                                                                true
                                                            );
                                                        }}
                                                        multiple={false}
                                                        onRemoveImage={() => {
                                                            onFormChange(
                                                                "webImageForegroundUrl",
                                                                ""
                                                            );
                                                            setFieldValue(
                                                                `webImageForegroundUrl`,
                                                                null
                                                            );
                                                            setFieldTouched(
                                                                `webImageForegroundUrl`,
                                                                true
                                                            );
                                                        }}
                                                        imageUrl={
                                                            values[
                                                                `webImageForegroundUrl`
                                                            ]
                                                        }
                                                        loader={
                                                            webFgImageLoader
                                                        }
                                                    />
                                                </>
                                            </Item>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={5}
                                            className="mb-2"
                                        >
                                            <Item>
                                                <>
                                                    <Typography
                                                        className="text-align-left"
                                                        variant="body1"
                                                        fontWeight={600}
                                                    >
                                                        Background Image
                                                    </Typography>
                                                    <StyledDropzone
                                                        height={150}
                                                        disabled={
                                                            !(
                                                                allowEdit &&
                                                                values?.backgroundSelection ==
                                                                    THEMATIC_BACKGROUNG_SELECTION.IMAGE
                                                            )
                                                        }
                                                        onDropFile={(
                                                            file: any
                                                        ) => {
                                                            onFormChange(
                                                                "webImageBackgroundUrl",
                                                                values.webImageBackgroundUrl
                                                            );
                                                            uploadImage(
                                                                file,
                                                                "webImageBackgroundUrl"
                                                            );
                                                            setFieldTouched(
                                                                `webImageBackgroundUrl`,
                                                                true
                                                            );
                                                        }}
                                                        multiple={false}
                                                        onRemoveImage={() => {
                                                            onFormChange(
                                                                "webImageBackgroundUrl",
                                                                ""
                                                            );
                                                            setFieldValue(
                                                                `webImageBackgroundUrl`,
                                                                null
                                                            );
                                                            setFieldTouched(
                                                                `webImageBackgroundUrl`,
                                                                true
                                                            );
                                                        }}
                                                        imageUrl={
                                                            values[
                                                                `webImageBackgroundUrl`
                                                            ]
                                                        }
                                                        errorMessage={
                                                            errors?.webImageBackgroundUrl
                                                        }
                                                        error={
                                                            touched?.webImageBackgroundUrl &&
                                                            errors?.webImageBackgroundUrl
                                                        }
                                                        loader={
                                                            webBgImageLoader
                                                        }
                                                    />
                                                </>
                                            </Item>
                                        </Grid>
                                    </Grid>

                                    {/* MOBILE IMAGE UPLOAD STARTS HERE */}
                                    <Typography variant="h6">Mobile</Typography>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            md={5}
                                            className="mb-2"
                                        >
                                            <Item>
                                                <>
                                                    <Typography
                                                        className="text-align-left"
                                                        variant="body1"
                                                        fontWeight={600}
                                                    >
                                                        Foreground Image
                                                    </Typography>
                                                    <StyledDropzone
                                                        height={150}
                                                        disabled={!allowEdit}
                                                        onDropFile={(
                                                            file: any
                                                        ) => {
                                                            onFormChange(
                                                                "mobileImageForegroundUrl",
                                                                values.mobileImageForegroundUrl
                                                            );
                                                            uploadImage(
                                                                file,
                                                                "mobileImageForegroundUrl"
                                                            );
                                                            setFieldTouched(
                                                                `mobileImageForegroundUrl`,
                                                                true
                                                            );
                                                        }}
                                                        multiple={false}
                                                        onRemoveImage={() => {
                                                            onFormChange(
                                                                "mobileImageForegroundUrl",
                                                                ""
                                                            );
                                                            setFieldValue(
                                                                `mobileImageForegroundUrl`,
                                                                null
                                                            );
                                                            setFieldTouched(
                                                                `mobileImageForegroundUrl`,
                                                                true
                                                            );
                                                        }}
                                                        imageUrl={
                                                            values[
                                                                `mobileImageForegroundUrl`
                                                            ]
                                                        }
                                                        errorMessage={
                                                            mobileFgimageErrMessage
                                                        }
                                                        loader={
                                                            mobileFgImageLoader
                                                        }
                                                    />
                                                </>
                                            </Item>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={5}
                                            className="mb-2"
                                        >
                                            <Item>
                                                <>
                                                    <Typography
                                                        className="text-align-left"
                                                        variant="body1"
                                                        fontWeight={600}
                                                    >
                                                        Background Image
                                                    </Typography>
                                                    <StyledDropzone
                                                        height={150}
                                                        disabled={
                                                            !(
                                                                allowEdit &&
                                                                values?.backgroundSelection ==
                                                                    THEMATIC_BACKGROUNG_SELECTION.IMAGE
                                                            )
                                                        }
                                                        onDropFile={(
                                                            file: any
                                                        ) => {
                                                            onFormChange(
                                                                "mobileImageBackgroundUrl",
                                                                values.mobileImageBackgroundUrl
                                                            );
                                                            uploadImage(
                                                                file,
                                                                "mobileImageBackgroundUrl"
                                                            );
                                                            setFieldTouched(
                                                                `mobileImageBackgroundUrl`,
                                                                true
                                                            );
                                                        }}
                                                        multiple={false}
                                                        onRemoveImage={() => {
                                                            onFormChange(
                                                                "mobileImageBackgroundUrl",
                                                                ""
                                                            );
                                                            setFieldValue(
                                                                `mobileImageBackgroundUrl`,
                                                                null
                                                            );
                                                            setFieldTouched(
                                                                `mobileImageBackgroundUrl`,
                                                                true
                                                            );
                                                        }}
                                                        imageUrl={
                                                            values[
                                                                `mobileImageBackgroundUrl`
                                                            ]
                                                        }
                                                        errorMessage={
                                                            errors?.mobileImageBackgroundUrl
                                                        }
                                                        error={
                                                            touched?.mobileImageBackgroundUrl &&
                                                            errors?.mobileImageBackgroundUrl
                                                        }
                                                        loader={
                                                            mobileBgImageLoader
                                                        }
                                                    />
                                                </>
                                            </Item>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                    )}

                    <div
                        {...dragHandleProps}
                        className={`${!showForm && "mt-3 "}d-flex j-space`}
                    >
                        {!showForm && (
                            <>
                                <span
                                    onClick={onOpenForm}
                                    className="curation-edit cursor-pointer"
                                >
                                    Edit Rail
                                </span>
                                <KeyboardArrowDownIcon
                                    className="cursor-pointer"
                                    onClick={onOpenForm}
                                />
                            </>
                        )}
                    </div>

                    {showForm && (
                        <div
                            {...dragHandleProps}
                            className="d-flex flex-column"
                        >
                            <div className="d-flex j-end">
                                {allowEdit && (
                                    <Button
                                        onClick={() =>
                                            thematicRailRef.current.handleSubmit()
                                        }
                                        className="max-content-width float-center align-right mr-2"
                                        variant="contained"
                                        type="button"
                                    >
                                        Save
                                    </Button>
                                )}
                                <KeyboardArrowUpIcon
                                    className="align-right cursor-pointer"
                                    onClick={onCloseRail}
                                />
                            </div>
                            {errorMessage && (
                                <div className="text-danger d-flex j-end publish-error-text">
                                    {errorMessage}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div
                    {...dragHandleProps}
                    className="curation-list-card-container-span"
                >
                    {!hideAddButton && allowEdit && (
                        <Tooltip title="Add New Rail">
                            <span
                                className="cursor-pointer add-circle-style"
                                onClick={onClickAdd}
                            >
                                <AddCircleOutlineIcon />
                            </span>
                        </Tooltip>
                    )}
                </div>
                <GeneralModalV1
                    title="Confirm upload"
                    isOpen={showInfoPopup}
                    handleClose={closeInfoModal}
                    handleConfirm={confirmUpload}
                >
                    <p>
                        {" "}
                        Replace current image with{" "}
                        {selectedFile && selectedFile?.files[0]?.name}?
                    </p>
                </GeneralModalV1>
            </div>
        );
    }
);

export default ThematicContentCurationCard;
